import { string } from 'prop-types';
import { DeprecatedLoader as Loader } from '@aon-coverwallet/cw-react-components';

const LoaderComponent = ({ subtitle = '' }) => (
  <Loader global>{subtitle}</Loader>
);

LoaderComponent.propTypes = {
  subtitle: string,
};

export { LoaderComponent };
